var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('height-tracker',{staticClass:"container-fluid",staticStyle:{"overflow":"hidden"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var height = ref.height;
return _c('div',{staticClass:"table-full-width"},[_c('data-table',_vm._g(_vm._b({staticStyle:{"width":"100%","position":"absolute","left":"0","top":"0"},attrs:{"height":height,"currency-symbol":_vm.getCurrencySymbols(),"table-column-type":_vm.getTableColumnTypes()}},'data-table',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)],1)}}],null,true)})}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9354d06e","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/data-table-full-height.vue
// module id = null
// module chunks = 